import { render, staticRenderFns } from "./private-sales-kata.vue?vue&type=template&id=0557271a&"
import script from "./private-sales-kata.vue?vue&type=script&lang=js&"
export * from "./private-sales-kata.vue?vue&type=script&lang=js&"
import style0 from "./private-sales-kata.vue?vue&type=style&index=0&id=0557271a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports